import { InboxItem, PageWrapper } from '@components/Dashboard/components'
import { ProjectsNotFound } from '@components/Dashboard/components/DashboardProjects/components/ProjectsList/components'
import { useWorkspaces } from '@components/Dashboard/hooks'
import { Button } from '@octopus-do/octopus-storybook'
import { InboxActions, selectInboxWorkspace } from '@store/reducers/inbox'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { clsJoin } from '@/utils'
import { useActivityPage } from './hooks'
import css from './styles.module.css'
import { groupByMonth } from './utils'

// What happened in the projects of this workspace, newest first, the unread
// rows lit; a page like Members, reached from the sidebar
export const Activity: React.FC = () => {
  const dispatch = useDispatch()
  const { current } = useWorkspaces()
  const workspace = current?.id ?? ''
  const { fresh, freshLoaded, earlier, earlierLoading, earlierDone } =
    useSelector(selectInboxWorkspace(workspace))
  const now = useActivityPage(workspace)

  if (!current) {
    return null
  }

  const handleReadAll = () => {
    dispatch(InboxActions.markAllRead({ workspace }))
  }

  const handleLoadMore = () => {
    const last = earlier[earlier.length - 1]

    if (last) {
      dispatch(InboxActions.fetchEarlier({ workspace, before: last.id }))
    }
  }

  const empty =
    freshLoaded && !earlierLoading && fresh.length === 0 && earlier.length === 0

  return (
    <div className={clsJoin(css.responsive, css.content)}>
      <PageWrapper title="Activity" plain>
        {empty && <ProjectsNotFound compact title="All clear" />}

        {fresh.length > 0 && (
          <section className={css.section}>
            <div className={css.heading}>
              <span>New to you</span>
              <Button
                label="Mark all as read"
                priority="ghost"
                size="xxsmall"
                onClick={handleReadAll}
              />
            </div>
            <div className={css.list} data-testid="activity_new">
              {fresh.map((item) => (
                <InboxItem key={item.id} item={item} now={now} />
              ))}
            </div>
          </section>
        )}

        {groupByMonth(earlier, now).map(({ label, items }) => (
          <section key={label} className={css.section}>
            <div className={css.heading}>
              <span>{label || 'Earlier'}</span>
            </div>
            <div className={css.list} data-testid="activity_earlier">
              {items.map((item) => (
                <InboxItem key={item.id} item={item} now={now} />
              ))}
            </div>
          </section>
        ))}

        {!earlierDone && earlier.length > 0 && (
          <div className={css.footer}>
            <Button
              label="Load more"
              loading={earlierLoading}
              priority="secondary"
              size="medium"
              onClick={handleLoadMore}
            />
          </div>
        )}
      </PageWrapper>
    </div>
  )
}
